import { pubsub } from '@services';

class UpsellProducts extends HTMLElement {
  #unsubscribers = [];
  connectedCallback() {
    this.form = this.closest('product-form');
    this.upsellProducts = this.querySelectorAll('input[type="radio"]');
    this.upsellProductsSwiper = this.querySelector('upsell-products-swiper');
    this.selectedProduct = {};

    this.upsellProducts.forEach((product) => {
      product.addEventListener('change', (event) => {
        this.#handleSelectedProduct(event.target.value);
      });
    });

    this.#unsubscribers.push(
      pubsub.subscribe('quantity:change', () =>
        this.#handleSelectedProduct(this.selectedProduct.id)
      )
    );

    setTimeout(() => {
      this.#handleSelectedProduct(this.upsellProducts[0].value);
    }, 300);
  }

  #handleSelectedProduct(value) {
    this.selectedProduct = {
      id: parseInt(value),
      quantity: parseInt(this.form.querySelector('quantity-input input').value) || 1,
      parent_id: parseInt(this.form.querySelector('input[name="variant-id"]').value),
    };

    this.form.upsellProducts = [this.selectedProduct];

    this.#handleProductAttribute(value);
    this.#syncSelectedProduct(value);
    this.#updateSwiperSlide(value);
  }

  #syncSelectedProduct(value) {
    this.upsellProducts.forEach((product) => {
      if (parseInt(product.value) === parseInt(value)) {
        product.checked = true;
      } else {
        product.checked = false;
      }
    });
  }

  #updateSwiperSlide(value) {
    const selectedProduct = this.upsellProductsSwiper.querySelector(`input[value="${value}"]`);
    const slideIndex = Array.from(
      this.upsellProductsSwiper.querySelectorAll('.swiper-slide')
    ).indexOf(selectedProduct.closest('.swiper-slide'));

    this.upsellProductsSwiper.swiper.slideTo(slideIndex);
  }

  #handleProductAttribute(value) {
    const upsellProductAttr = this.form.querySelector('input[name="properties[_addon_id]"]');
    if (upsellProductAttr) {
      upsellProductAttr.value = value;
    } else {
      const upsellProductAttr = document.createElement('input');
      upsellProductAttr.type = 'hidden';
      upsellProductAttr.name = 'properties[_addon_id]';
      upsellProductAttr.value = value;
      this.form.querySelector('form').appendChild(upsellProductAttr);
    }
  }
}

customElements.define('upsell-products', UpsellProducts);
